'use client'

import { FunctionComponent } from 'react'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const defaultOffset = {
  top: '1rem',
  right: '1rem',
  bottom: 'var(--spacing-miista-bottom-offset,--spacing-miista-page-padding)',
  left: '1rem',
}

const Toaster: FunctionComponent<ToasterProps> = ({ ...props }) => {
  // Uncomment to test.
  // toast.success('TEST')

  return (
    <Sonner
      theme='light'
      className='toaster group'
      offset={defaultOffset}
      mobileOffset={defaultOffset}
      toastOptions={{
        classNames: {
          toast: 'group !p-3 !gap-3 !rounded-lg toast !bg-popover !text-popover-foreground !border-border !text-base !shadow-none',
          description: 'group-[.toast]:!text-muted-foreground',
          actionButton: 'group-[.toast]:!bg-primary group-[.toast]:!text-primary-foreground',
          cancelButton: 'group-[.toast]:!bg-muted group-[.toast]:!text-muted-foreground',
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
